var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5123_1710)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M21 41.7578C32.0457 41.7578 41 32.8035 41 21.7578C41 10.7121 32.0457 1.75781 21 1.75781C9.9543 1.75781 1 10.7121 1 21.7578C1 32.8035 9.9543 41.7578 21 41.7578Z",
    stroke: "#F9F5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9234 11.9869C22.3622 11.9869 23.8009 11.907 25.2263 12.0002C28.0638 12.1998 30.3152 14.6086 30.3685 17.4566C30.4084 20.1049 30.4084 22.7532 30.3685 25.3882C30.3152 28.4225 27.8373 30.8446 24.7334 30.8978C22.1757 30.9377 19.6179 30.9377 17.0602 30.8978C13.823 30.8446 11.4251 28.3826 11.3984 25.1353C11.3984 22.6734 11.3984 20.2113 11.3984 17.7493C11.3984 14.4223 13.8363 11.9736 17.1667 11.9337C18.419 11.9203 19.6712 11.9337 20.9234 11.9337V11.9736V11.9869ZM13.1436 21.449C13.1436 22.6601 13.1436 23.8711 13.1436 25.0821C13.1436 27.4377 14.7821 29.1279 17.14 29.1544C19.6446 29.1811 22.1357 29.1944 24.6401 29.1544C26.9581 29.1145 28.61 27.4244 28.61 25.0955C28.61 22.6467 28.61 20.2113 28.61 17.7626C28.61 15.4337 26.9715 13.7303 24.6534 13.6903C22.1224 13.6504 19.5779 13.6504 17.0468 13.6903C14.7821 13.7303 13.1569 15.4204 13.1436 17.6828C13.1436 18.9337 13.1436 20.1847 13.1436 21.4224V21.449Z",
    fill: "#F9F5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8727 16.9277C23.3542 16.9277 25.3855 18.9463 25.3984 21.4149C25.3984 23.8834 23.3798 25.9277 20.9113 25.9277C18.4299 25.9277 16.3984 23.9091 16.3984 21.4406C16.3984 18.9592 18.417 16.9277 20.8856 16.9277H20.8727ZM17.967 21.4277C17.967 23.022 19.2785 24.3463 20.8727 24.3591C22.467 24.3591 23.7913 23.0477 23.8041 21.4534C23.8041 19.872 22.4927 18.5348 20.8984 18.522C19.3041 18.522 17.9799 19.8334 17.967 21.4277Z",
    fill: "#F9F5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4106 17.9277C24.8619 17.9277 24.4107 17.4888 24.3984 16.9522C24.3984 16.3913 24.8741 15.9158 25.4228 15.928C25.9716 15.9402 26.3984 16.3913 26.3984 16.9401C26.3984 17.501 25.9594 17.9277 25.4106 17.9277Z",
    fill: "#F9F5EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5123_1710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.757812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramicon);
export default __webpack_public_path__ + "static/media/instagramicon.7d9c5c3d29fdbecc4ba548e3a262f1ad.svg";
export { ForwardRef as ReactComponent };